/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import { withRouter } from "react-router-dom";
import { TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { issueCardListAction, issueRechargeCardListAction, totalIssueTicketOnCardAction } from "../../../redux/action-creators/cardCollectionActionCreator";

// type of component can be recharge, card & ticket

class IssueList extends React.Component {
  constructor(props) {
    super(props);
    const m = moment(new Date());
    this.state = {
      showHeaderButton: true,
      pageNo: 0,
      rowsPerPage: 10,
      isUserAViewer: false,
      date: m,
      todaySelectable: true,
      backdrop: false,
      content: [],
      selected: [],
      sortBy: "",
    };
    this.issueGetList = this.issueGetList.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  componentDidMount() {
    this.issueGetList();
  }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.issueGetList();
      }
    });
  };

  // eslint-disable-next-line class-methods-use-this
  handleAction() {
    // Handle action
  }

  issueGetList() {
    const {
      location, cityFilter, selectedDateFilter, fetchCardCollection,
      componentType, fetchRechargeCardCollection, fetchTicketCollection,
    } = this.props;
    const { pageNo, rowsPerPage } = this.state;
    const {
      cityId = "", depotId = "", fromDate = "", toDate = "", busNumber = "",
    } = location.state;
    const data = {
      cityId,
      depotId,
      fromDate,
      toDate,
      busNumber,
      cityFilter,
      pageNo,
      pageSize: rowsPerPage,
      dateFilter: selectedDateFilter,
    };
    if (componentType === "card") {
      fetchCardCollection(data);
    } else if (componentType === "recharge") {
      fetchRechargeCardCollection(data);
    } else {
      fetchTicketCollection(data);
    }
  }

  render() {
    const {
      headerLoader, content, totalItems, componentType,
    } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy,
    } = this.state;
    const uniqueKey = componentType === "ticket" ? "transactionid" : "busNumber";
    const templateString = componentType === "ticket"
      ? templateStrings.issueTicketList
      : componentType === "recharge"
        ? templateStrings.rechargeCardList
        : templateStrings.issueCardList;
    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey={uniqueKey}
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateString}
          selectionAllowed={false}
          handleAction={this.handleAction}
          sortBy={sortBy}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const getData = (type) => {
    if (ownProps.componentType === "ticket") {
      return state?.CardCollection?.issueTicketOnCard[type];
    }
    if (ownProps.componentType === "recharge") {
      return (state?.CardCollection?.cardRecharged[type]);
    }
    return state?.CardCollection?.cardIssued[type];
  };
  return {
    content: getData("content") || [],
    totalItems: getData("totalItems") || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchTicketCollection: (params) => {
    dispatch(totalIssueTicketOnCardAction(params));
  },
  fetchRechargeCardCollection: (params) => {
    dispatch(issueRechargeCardListAction(params));
  },
  fetchCardCollection: (params) => {
    dispatch(issueCardListAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IssueList));
